import classNames from 'classnames';
import type { ReactNode } from 'react';
import styled, { type CSSProperties } from 'styled-components';

import { NeonEdge } from '@sorare/core/src/atoms/ui/NeonEdge';
import {
  ensureHexColor,
  getRgbColorFromHex,
} from '@sorare/core/src/lib/colors';

const Root = styled.div`
  position: relative;
  padding: var(--double-unit);
  border-radius: var(--double-unit);
  background:
    conic-gradient(
        from 90deg at 6px 6px,
        rgba(var(--background-overlay-color), 0.1) 25%,
        var(--c-black) 0
      )
      0 0/8px 8px,
    conic-gradient(from 90deg at 6px 6px, var(--c-nd-50) 25%, var(--c-black) 0)
      0 0/8px 8px,
    var(--c-black);

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: var(--double-unit);
    opacity: 0;
    transition: opacity 1s;
    box-shadow: 0 0 32px 4px rgba(var(--background-overlay-color), 0.5);
  }
  &.showHalo::before {
    opacity: 1;
  }
`;
const StyledNeonEdge = styled(NeonEdge)`
  position: absolute;
  inset: 0;
  overflow: hidden;
  border-radius: var(--double-unit);
`;

type Props = { children: ReactNode; color: string | null; showHalo?: boolean };
export const MissionToastBackground = ({
  children,
  color,
  showHalo,
}: Props) => {
  const hexColor = ensureHexColor(color);

  return (
    <Root
      style={
        {
          '--background-overlay-color': getRgbColorFromHex(hexColor),
        } as CSSProperties
      }
      className={classNames({ showHalo })}
    >
      <StyledNeonEdge
        color={hexColor}
        side="left"
        showHalo="always"
        haloOpacity={0.6}
        spread="60%"
      />
      {children}
    </Root>
  );
};
